import { getStrapiMedia } from "utils";

const IconSetComponent = ({
  iconSet,
  iconGroups,
}: {
  iconSet: any;
  iconGroups: any;
}) => {
  return (
    <div className="icon-set-groups">
      {iconGroups &&
        iconGroups.map((iconGroup: any, index: number) => (
          <div key={index} className="icon-set-groups__item">
            <h6>{iconGroup.attributes.Label}</h6>
            <IconSetItem
              iconSet={iconSet}
              iconGroup={iconGroup.attributes.Label}
            />
          </div>
        ))}
    </div>
  );
};

const IconSetItem = ({
  iconSet,
  iconGroup,
}: {
  iconSet: any;
  iconGroup: string;
}) => {
  return (
    <div className="icon-set">
      {iconSet.map((icon: any, index: number) => {
        if (
          icon.attributes.theme_icon_group.data.attributes.Label === iconGroup
        ) {
          return (
            <div key={index} className="icon-set__item">
              <IconElement icon={icon} />
              <p className="icon-set__item-label">{icon.attributes.Label}</p>
            </div>
          );
        }
      })}
    </div>
  );
};

function IconElement({ icon }: { icon: any }) {
  const { svg, Image: img } = icon?.attributes;

  if (svg && svg.includes("<svg") && svg.includes("</svg>")) {
    return <div dangerouslySetInnerHTML={{ __html: svg.trim() }} />;
  }

  if (img && img.data) {
    return <img src={getStrapiMedia(img)} alt={icon.attributes.Label} />;
  }

  return null;
}

export default IconSetComponent;
